import { PhosphorManifyingGlassButton } from "components/Atoms/PhosphorIconButton";
import { Checkbox } from "components/Atoms/inputs/Checkbox";
import ChooseTemplateButton from "components/MessageTemplate/ChooseTemplateButton";
import OptionalTextInput from "components/ValidatedFields/OptionalTextInput";
import React from "react";
import { Utils } from "../../common/utils";
import { Modal } from "../../components";
import SelectMultipleEmailAddresses from "../../components/AddressBook/SelectMultipleEmailAddresses";
import OptionalTextAreaInput from "components/ValidatedFields/OptionalTextAreaInput";
import { TextArea } from "components/Atoms/formInputs/TextArea";

interface Props {
  config: server.dto.LinkedEmailPanelConfig
  onTemplateSelected: (template: server.dto.MessageTemplate, language: server.dto.Languages) => void
  templateType: server.dto.MessageTemplateTypes
  showErrors: boolean
  suggestedApiInstruction: server.dto.ListContactAddressBookToItemInstruction

  charachtersLeft: number

  to: string
  toChanged: (newTo: string) => void

  cc: string
  ccChanged: (newCc: string) => void

  bcc: string
  bccChanged: (newBcc: string) => void

  subject: string
  subjectChanged: (newSubject: string) => void

  showVisibleToExernalUser: boolean
  visibleToExternalUser: boolean
  visibleToExternalUserToggled: () => void
}

const EmailHeaderTable = (props: Props) => {
  const [contactSearch, setContactSearch] = React.useState<"to" | "cc" | "bcc">(undefined);
  const [contactSearchInitialValue, setContactSearchInitialValue] = React.useState<string>("");

  const onContactSearchChanged = (emails: string) => {
    let setter;
    switch (contactSearch) {
      case "to": setter = props.toChanged; break;
      case "cc": setter = props.ccChanged; break;
      case "bcc": setter = props.bccChanged; break;
    }

    setter(emails);
    setContactSearch(undefined);
  };

  const onToSearch = () => {
    setContactSearch("to");
    setContactSearchInitialValue(props.to);
  };

  const onCcSearch = () => {
    setContactSearch("cc");
    setContactSearchInitialValue(props.cc);
  };

  const onBccSearch = () => {
    setContactSearch("bcc");
    setContactSearchInitialValue(props.bcc);
  };

  return <>
    {contactSearch && <Modal
      isOpen={contactSearch != null}
      handleClose={() => { setContactSearch(undefined); }}
      title={RESX.Contact.FindContact}
      width="small"
      height={750}
    >
      <SelectMultipleEmailAddresses
        onEmailsSelected={onContactSearchChanged}
        initialEmails={contactSearchInitialValue}
        suggestedApiInstruction={props.suggestedApiInstruction}
      />
    </Modal>}
    <table className="s1_table bordergrid gray ">
      <tbody>
        <tr>
          <td>{RESX.Template.EmailTemplate}</td>
          <td>
            <div className="flex justify-space-between align-center gap-small">
              <ChooseTemplateButton
                type={props.templateType}
                buttonLabel={RESX.EmailTemplate.resxEmailTemplate}
                onTemplateSelected={props.onTemplateSelected}
              />
            </div>
          </td>
        </tr>
        <tr>
          <td>{RESX.Message.lblTo}</td>
          <td>
            <div className="flex gap-small">
              <PhosphorManifyingGlassButton
                onClick={onToSearch}
                layout="in-square"
                backgroundColor="light"
                padding="large"
              />
              <TextArea
                maxLength={999}
                rows={1}
                value={props.to}
                onChange={value => { props.toChanged(value.toString()); }}
                onBlur={() => { props.toChanged(Utils.processManualRecipientsString(props.to)); }}
                error={props.showErrors && props.to.trim() === ""}
              />
            </div>
          </td>
        </tr>
        <tr>
          <td>{RESX.Message.lblCC}</td>
          <td>
            <div className="flex gap-small">
              <PhosphorManifyingGlassButton
                onClick={onCcSearch}
                layout="in-square"
                backgroundColor="light"
                padding="large"
              />
              <OptionalTextAreaInput
                maxLength={9999}
                rows={1}
                value={props.cc}
                onChange={value => { props.ccChanged(value.toString()); }}
                onBlur={() => { props.ccChanged(Utils.processManualRecipientsString(props.cc)); }}
              />
            </div>
          </td>
        </tr>
        <tr>
          <td>{RESX.Message.lblBcc}</td>
          <td>
            <div className="flex gap-small">
              <PhosphorManifyingGlassButton
                onClick={onBccSearch}
                layout="in-square"
                backgroundColor="light"
                padding="large"
              />
              <OptionalTextAreaInput
                maxLength={9999}
                rows={1}
                value={props.bcc}
                onChange={value => { props.bccChanged(value.toString()); }}
                onBlur={() => { props.bccChanged(Utils.processManualRecipientsString(props.bcc)); }}
              />
            </div>
          </td>
        </tr>{
          props.showVisibleToExernalUser &&
          <tr>
            <td>{RESX.GeneralLabels.Visible}</td>
            <td className="s1_cell_bigpadding">
              <Checkbox
                onChange={props.visibleToExternalUserToggled}
                checked={props.visibleToExternalUser}
                label={RESX.GeneralLabels.VisibleToExternalUsers} />
            </td>
          </tr>}
        <tr>
          <td>{RESX.Message.Subject}</td>
          <td className="flex align-center">
            <OptionalTextInput
              hasError={props.showErrors && props.subject.trim() === ""}
              maxLength={serverReference.constants.emailMessage.maxSubjectLength}
              value={props.subject}
              onChange={props.subjectChanged}
            />
            <div
              className="padding-right"
              style={{ textAlign: "right", width: 100, fontSize: "24px", color: props.charachtersLeft < 0 ? "var(--input-error-text)" : "var(--text-color-light)" }}
            >
              {props.charachtersLeft}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </>;
};

export default EmailHeaderTable;